<template>
  <div class="contain">
    <img src="../assets/bg@2x.png" alt="" class="topbgc">
    <div class="down" @click="down" v-if="!isAndroid">
      <img src="../assets/苹果@2x.png" alt="">
      <span>iPhone版下载</span>
    </div>
    <div class="down and" @click="and" v-else>
      <img src="../assets/安卓@2x.png" alt="">
      <span>Android版下载</span>
    </div>
    <div class="tit">
      <img src="../assets/三角形@2x.png" alt="">
      <span>其他下载方式</span>
    </div>
    <div class="ms">
      <div>1.苹果手机在App Store搜索“高净值研究院“直接下载；</div>
      <div>2.其他型号手机请在：应用宝，华为，小米等应用商店搜索”高净值研究院“直接下载</div>
    </div>
    <div class="bgc" v-show="showDownImg">
      <img src="../assets/newAn.png" alt="">
    </div>
  </div>
</template>

<script>
  import {
    downloadApp
  } from '../api/agreement'

  export default {
    name: 'Download',
    data() {
      return {
        isInWeChat: /MicroMessenger/i.test(navigator.userAgent),
        showDownImg: false,
        isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1
      }
    },
    methods: {
      async and() {
        console.log(this.isInWeChat)
        if (this.isInWeChat) {
          this.showDownImg = true
        } else {
          const data = await downloadApp('安卓手动下载包')
          console.log(data.data.data.url)
          const a = document.createElement('a')
          a.href = data.data.data.url
          a.download = 'gjz.apk'
          a.click()
        }
      },
      down() {
        window.location.href = 'https://apps.apple.com/cn/app/id6467824331'
        // console.log(11)
        // const u = navigator.userAgent // 判断是安卓还是iOS
        // console.log(u)
        // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // 判断是否是 android终端
        // if (isAndroid) {
        //   window.location.href = 'https://play.google.com/store/apps/details?id='
        // } else {
        //   window.location.href = 'https://apps.apple.com/cn/app/id6467824331'
        // }
      }
    }
  }
</script>

<style scoped lang="less">
  .contain {
    height: 100%;
    width: 100%;
    background: #fff;

    .topbgc {
      width: 750px;
      height: 850px;
    }

    .down {
      width: 670px;
      height: 90px;
      background: #1D4687;
      box-shadow: 0px 4px 10px 0px rgba(94, 94, 94, 0.2);
      border-radius: 10px;
      margin: 40px auto 20px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 90px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 36px;
        height: 44px;
        //vertical-align: center;
        margin-top: -5px;
        margin-right: 40px;
      }

      span {
        vertical-align: bottom;
      }
    }

    .and {
      margin-top: 20px !important;
      margin-bottom: 53px;
    }

    .tit {
      padding-left: 62px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      img {
        width: 12px;
        height: 17px;
        margin-right: 14px;
      }

      span {
        font-size: 30px;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
      }
    }

    .ms {
      padding: 0 55px 0 40px;

      div {
        font-size: 26px;
        font-weight: 400;
        color: #666666;
        line-height: 37px;
      }
    }
  }

  .bgc {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: gray;

    //opacity: .9;
    img {
      touch-action: manipulation;
      display: block;
      /* 去除图片下方的默认空白间距 */
      /* 防止浏览器默认的双指缩放操作 */
      width: 100%;
      height: 100%;
    }
  }
</style>